/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/job_scope_change.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var shared_types_decimal_pb = require('../shared/types/decimal_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./job_scope_change_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.JobScopeUpdateRequest,
 *   !proto.worklayer.internal.v1.JobScopeUpdateResponse>}
 */
const methodDescriptor_JobScopeChangeService_JobScopeUpdate = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/JobScopeUpdate',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.JobScopeUpdateRequest,
  proto.worklayer.internal.v1.JobScopeUpdateResponse,
  /**
   * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.JobScopeUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.JobScopeUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.JobScopeUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.jobScopeUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/JobScopeUpdate',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_JobScopeUpdate,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.JobScopeUpdateResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.jobScopeUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/JobScopeUpdate',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_JobScopeUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.JobScopeUpdateRequest,
 *   !proto.worklayer.internal.v1.JobScopeUpdateResponse>}
 */
const methodDescriptor_JobScopeChangeService_DraftJobScopeUpdate = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/DraftJobScopeUpdate',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.JobScopeUpdateRequest,
  proto.worklayer.internal.v1.JobScopeUpdateResponse,
  /**
   * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.JobScopeUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.JobScopeUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.JobScopeUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.draftJobScopeUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/DraftJobScopeUpdate',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_DraftJobScopeUpdate,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.JobScopeUpdateResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.draftJobScopeUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/DraftJobScopeUpdate',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_DraftJobScopeUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CreateJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.CreateJobScopeChangeResponse>}
 */
const methodDescriptor_JobScopeChangeService_CreateJobScopeChange = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/CreateJobScopeChange',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CreateJobScopeChangeRequest,
  proto.worklayer.internal.v1.CreateJobScopeChangeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CreateJobScopeChangeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CreateJobScopeChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CreateJobScopeChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.createJobScopeChange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/CreateJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_CreateJobScopeChange,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CreateJobScopeChangeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.createJobScopeChange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/CreateJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_CreateJobScopeChange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest,
 *   !proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse>}
 */
const methodDescriptor_JobScopeChangeService_EditJobScopeChangeItems = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/EditJobScopeChangeItems',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest,
  proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.editJobScopeChangeItems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/EditJobScopeChangeItems',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_EditJobScopeChangeItems,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.EditJobScopeChangeItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.EditJobScopeChangeItemsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.editJobScopeChangeItems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/EditJobScopeChangeItems',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_EditJobScopeChangeItems);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse>}
 */
const methodDescriptor_JobScopeChangeService_FinalizeJobScopeChange = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/FinalizeJobScopeChange',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest,
  proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.finalizeJobScopeChange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/FinalizeJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_FinalizeJobScopeChange,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.FinalizeJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.FinalizeJobScopeChangeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.finalizeJobScopeChange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/FinalizeJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_FinalizeJobScopeChange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ApproveJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.ApproveJobScopeChangeResponse>}
 */
const methodDescriptor_JobScopeChangeService_ApproveJobScopeChange = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/ApproveJobScopeChange',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ApproveJobScopeChangeRequest,
  proto.worklayer.internal.v1.ApproveJobScopeChangeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ApproveJobScopeChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.approveJobScopeChange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ApproveJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ApproveJobScopeChange,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.approveJobScopeChange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ApproveJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ApproveJobScopeChange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RejectJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.RejectJobScopeChangeResponse>}
 */
const methodDescriptor_JobScopeChangeService_RejectJobScopeChange = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/RejectJobScopeChange',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RejectJobScopeChangeRequest,
  proto.worklayer.internal.v1.RejectJobScopeChangeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RejectJobScopeChangeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RejectJobScopeChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RejectJobScopeChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.rejectJobScopeChange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/RejectJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_RejectJobScopeChange,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RejectJobScopeChangeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.rejectJobScopeChange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/RejectJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_RejectJobScopeChange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ApproveJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.ApproveJobScopeChangeResponse>}
 */
const methodDescriptor_JobScopeChangeService_ApproveJobScopeChangeOnBehalfOfClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/ApproveJobScopeChangeOnBehalfOfClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ApproveJobScopeChangeRequest,
  proto.worklayer.internal.v1.ApproveJobScopeChangeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ApproveJobScopeChangeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ApproveJobScopeChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.approveJobScopeChangeOnBehalfOfClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ApproveJobScopeChangeOnBehalfOfClient',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ApproveJobScopeChangeOnBehalfOfClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ApproveJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ApproveJobScopeChangeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.approveJobScopeChangeOnBehalfOfClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ApproveJobScopeChangeOnBehalfOfClient',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ApproveJobScopeChangeOnBehalfOfClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RejectJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.RejectJobScopeChangeResponse>}
 */
const methodDescriptor_JobScopeChangeService_RejectJobScopeChangeOnBehalfOfClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/RejectJobScopeChangeOnBehalfOfClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RejectJobScopeChangeRequest,
  proto.worklayer.internal.v1.RejectJobScopeChangeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RejectJobScopeChangeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RejectJobScopeChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RejectJobScopeChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.rejectJobScopeChangeOnBehalfOfClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/RejectJobScopeChangeOnBehalfOfClient',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_RejectJobScopeChangeOnBehalfOfClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RejectJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RejectJobScopeChangeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.rejectJobScopeChangeOnBehalfOfClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/RejectJobScopeChangeOnBehalfOfClient',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_RejectJobScopeChangeOnBehalfOfClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.JobScopeChange>}
 */
const methodDescriptor_JobScopeChangeService_GetJobScopeChange = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChange',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobScopeChangeRequest,
  proto.worklayer.internal.v1.JobScopeChange,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.JobScopeChange.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.JobScopeChange)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.JobScopeChange>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.getJobScopeChange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChange,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.JobScopeChange>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.getJobScopeChange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChange',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobScopeChangeRequest,
 *   !proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse>}
 */
const methodDescriptor_JobScopeChangeService_GetJobScopeChangePriceBreakdownForClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangePriceBreakdownForClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobScopeChangeRequest,
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.getJobScopeChangePriceBreakdownForClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangePriceBreakdownForClient',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChangePriceBreakdownForClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForClientResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.getJobScopeChangePriceBreakdownForClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangePriceBreakdownForClient',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChangePriceBreakdownForClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest,
 *   !proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse>}
 */
const methodDescriptor_JobScopeChangeService_GetJobScopeChangePriceBreakdownForAdmin = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangePriceBreakdownForAdmin',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest,
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.getJobScopeChangePriceBreakdownForAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangePriceBreakdownForAdmin',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChangePriceBreakdownForAdmin,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangePriceBreakdownForAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.JobScopeChangePriceBreakdownForAdminResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.getJobScopeChangePriceBreakdownForAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangePriceBreakdownForAdmin',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChangePriceBreakdownForAdmin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest,
 *   !proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse>}
 */
const methodDescriptor_JobScopeChangeService_GetJobScopeChangeStatusAggregations = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangeStatusAggregations',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest,
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.getJobScopeChangeStatusAggregations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangeStatusAggregations',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChangeStatusAggregations,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetJobScopeChangeStatusAggregationsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.getJobScopeChangeStatusAggregations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/GetJobScopeChangeStatusAggregations',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_GetJobScopeChangeStatusAggregations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListJobScopeChangesRequest,
 *   !proto.worklayer.internal.v1.ListJobScopeChangesResponse>}
 */
const methodDescriptor_JobScopeChangeService_ListJobScopeChanges = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/ListJobScopeChanges',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListJobScopeChangesRequest,
  proto.worklayer.internal.v1.ListJobScopeChangesResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListJobScopeChangesResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListJobScopeChangesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListJobScopeChangesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.listJobScopeChanges =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ListJobScopeChanges',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ListJobScopeChanges,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListJobScopeChangesResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.listJobScopeChanges =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ListJobScopeChanges',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ListJobScopeChanges);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest,
 *   !proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse>}
 */
const methodDescriptor_JobScopeChangeService_ListJobScopeChangesForCollaborator = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobScopeChangeService/ListJobScopeChangesForCollaborator',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest,
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobScopeChangeServiceClient.prototype.listJobScopeChangesForCollaborator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ListJobScopeChangesForCollaborator',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ListJobScopeChangesForCollaborator,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListJobScopeChangesForCollaboratorResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobScopeChangeServicePromiseClient.prototype.listJobScopeChangesForCollaborator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobScopeChangeService/ListJobScopeChangesForCollaborator',
      request,
      metadata || {},
      methodDescriptor_JobScopeChangeService_ListJobScopeChangesForCollaborator);
};


module.exports = proto.worklayer.internal.v1;

